import { BiddingIntradayOrderOrderMethod } from '@ebalance/proto/bffuser/v1/bidding_intraday_model_pb'

/**
 * 時間前の注文が成行 (= 価格を指定しない注文、 intraday-bidding.md AC-BIN-004d) かを判定する
 * 唯一の口。 一覧の表示行 (`IntradayBidRow` の `isMarketOrderRow`) と売買逆転の判定
 * (`~/models/intradayBidInversion`) が同じ判定を使う。
 *
 * `undefined` (= field 未設定の防御的ケース) と `UNSPECIFIED` はどちらも指値扱いに
 * する (SpotBidRow の `isMarketOrderRow` と同じ境界解決)。
 */
export const isIntradayMarketOrder = (order: {
  orderMethod?: BiddingIntradayOrderOrderMethod
}): boolean => order.orderMethod === BiddingIntradayOrderOrderMethod.MARKET
